import type { SiteLayoutRefusal } from './types';

export const STALE_DRAFT_MESSAGE =
  'This draft changed since you opened it. Review it and save again.';

/** One refusal in the designer's words: a field refusal in the server's own. */
export const refusalText = (refusal: SiteLayoutRefusal): string => {
  switch (refusal.code) {
    case 'STALE_DRAFT':
      return STALE_DRAFT_MESSAGE;
    case 'NO_DRAFT':
    case 'REVISION_MISMATCH':
      return 'This draft was published or discarded since you opened it. Review the current layout before making changes.';
    case 'FIELD':
      return refusal.message;
    case 'ZONE_IN_USE':
      return 'Entries still face this zone.';
    case 'SEED_REQUIRED':
      return 'Publishing needs an entry for each of these gateways. Add their entries, then publish again.';
    default:
      return 'Choose a zone for each gateway.';
  }
};

/** A command the server refused, writing nothing; the refusals say why. */
export class SiteLayoutRefusedError extends Error {
  constructor(public readonly refusals: SiteLayoutRefusal[]) {
    super(refusals.map(refusalText).join(' '));
    this.name = 'SiteLayoutRefusedError';
  }
}
